<template>
  <Card title="Willkommen bei just-feebdack" topic="Start">
    <template v-slot:body>
      <v-container
        class="mx-auto my-5 align-content-center text-center"
        max-width="400px"
      >
        <v-icon size="50%">{{ icons.mdiTools }}</v-icon>

        <v-card-title>Hier wird gebaut!</v-card-title>
        <v-divider class="ma-2" />
        <v-icon>{{ icons.mdiFormatQuoteOpenOutline }}</v-icon>
        <v-card-text class="text-center">
          Jeden Tag ein bisschen besser!
          <br /><br />
          Die Summe vieler kleiner Schritte erzeugt ein riesiges Ergebnis!
        </v-card-text>
        <v-icon>{{ icons.mdiFormatQuoteCloseOutline }}</v-icon>
      </v-container>
    </template>
  </Card>
</template>

<script>
import {
  mdiTools,
  mdiFormatQuoteOpenOutline,
  mdiFormatQuoteCloseOutline
} from "@mdi/js";
import Card from "./cards/Card";

export default {
  name: "UnderConstruction",
  components: { Card },
  data: () => ({
    icons: {
      mdiTools,
      mdiFormatQuoteCloseOutline,
      mdiFormatQuoteOpenOutline
    }
  })
};
</script>

<style scoped></style>
